import { createFileRoute } from '@tanstack/react-router'
import { ProjectInsightsSettingsSection } from '../../../features/projects/insights/settings-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/project-insights')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'project-insights'),
  component: ProjectInsightsSettingsSection,
})
